// Modules
import React, { useCallback, useEffect, useState } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useHistory, useLocation } from 'react-router-dom'

// Application
import { useAppHook, useRedirectExternalUniqueToken } from 'hooks'
import { usePhasedLogin } from 'redesign/hooks/usePhasedLogin'
import { getQueryParamsValue } from 'utils'

// Components
import { FullPageLoading } from 'components'
import { LoginWrapper } from './components'
import { ROUTES_PATH } from 'constants/routesPath'
import { TemplateContainer } from 'redesign/components/templates'

// eslint-disable-next-line prefer-destructuring
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''

export const Login: React.VFC = () => {
    const history = useHistory()
    const location = useLocation()
    const { toast, closeToast } = useAppHook()
    const [loading, setLoading] = useState(true)
    const { phasedLoginVisibility } = usePhasedLogin()
    const { verifyQueryParamsAndSaveSessionStorage } = useRedirectExternalUniqueToken()

    useEffect(() => {
        if (toast.show && toast.link) {
            closeToast()
        }
    }, [toast.show, toast.link, closeToast])

    const onInit = useCallback(() => {
        verifyQueryParamsAndSaveSessionStorage()

        const isUserFromPhasedLogin = getQueryParamsValue(location, 'phased-login-origin')

        if (phasedLoginVisibility && !isUserFromPhasedLogin) {
            history.replace({
                ...location,
                pathname: ROUTES_PATH.SIGN_IN,
            })
        } else {
            setLoading(false)
        }
    }, [history, location, phasedLoginVisibility, verifyQueryParamsAndSaveSessionStorage])

    useEffect(() => {
        // eslint-disable-next-line no-console

        onInit()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (loading) {
        return <FullPageLoading />
    }

    return (
        <TemplateContainer renderHeader>
            <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useEnterprise>
                <LoginWrapper />
            </GoogleReCaptchaProvider>
        </TemplateContainer>
    )
}
